import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["background", "content"]

  connect() {
    // フラッシュメッセージが存在する場合はモーダルを表示しない
    if (this.hasFlashMessage()) {
      this.element.classList.add("hidden")
      return
    }
  }

  disconnect() {
  }

  // フラッシュメッセージの存在確認
  hasFlashMessage() {
    // 通知またはアラートのフラッシュメッセージ要素を探す
    const flashNotice = document.querySelector('.bg-green-100.border.border-green-400')
    const flashAlert = document.querySelector('.bg-red-100.border.border-red-400')
    return !!(flashNotice || flashAlert)
  }

  openModal() {
    // モーダルが既に開いている場合は処理しない
    if (this.element.classList.contains('hidden')) {
      return
    }

    // アニメーション適用
    setTimeout(() => {
      this.backgroundTarget.classList.remove("opacity-0")
      this.backgroundTarget.classList.add("opacity-100")
      this.contentTarget.classList.remove("opacity-0", "translate-y-8", "scale-95")
      this.contentTarget.classList.add("opacity-100", "translate-y-0", "scale-100")
    }, 10)

    // 背景スクロールを防止
    document.body.classList.add("overflow-hidden")
  }

  // 同意するボタンがクリックされたときの処理
  agree(event) {
    if (event) {
      event.preventDefault()
    }

    // モーダルを閉じるアニメーション
    this.backgroundTarget.classList.remove("opacity-100")
    this.backgroundTarget.classList.add("opacity-0")
    this.contentTarget.classList.remove("opacity-100", "translate-y-0", "scale-100")
    this.contentTarget.classList.add("opacity-0", "translate-y-8", "scale-95")

    // モーダルを非表示
    setTimeout(() => {
      this.element.classList.add("hidden")
      document.body.classList.remove("overflow-hidden")
    }, 300)
  }

  // 同意しないボタンがクリックされたときの処理
  disagree(event) {
    if (event) {
      event.preventDefault()
    }

    // ブラウザバック
    window.history.back()
  }
}